<div class="container-keep-moving">
  <app-container
    [showCorners]="false"
  >
    <div class="container-keep-moving__content">
      <app-lottie-icon
        lottieJson="/assets/lotties/LoadingKeepMoving.json"
        width="140px"
        height="20px"
      ></app-lottie-icon>
      <p class="container-keep-moving__content__title">
        {{ keepMovingText }}
      </p>
    </div>
  </app-container>
</div>
